"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogStore = void 0;
/**
 * Logger store component to store logs
 */
var LogStore = /** @class */ (function () {
    function LogStore() {
        this.logs = [];
    }
    LogStore.prototype.getSize = function () {
        return this.logs.length;
    };
    LogStore.prototype.push = function (logData) {
        this.logs.push(logData);
    };
    LogStore.prototype.pushBatch = function (logs) {
        var _a;
        (_a = this.logs).push.apply(_a, logs);
    };
    LogStore.prototype.pop = function (logsCount) {
        if (logsCount === void 0) { logsCount = 0; }
        // if logsCount is not natural number,
        // then we don't need to splice anything
        if (logsCount <= 0) {
            return [];
        }
        // if the logs count is bigger, the splice will rotate
        // hence we just remove splice entire array list
        if (logsCount > this.getSize()) {
            logsCount = this.getSize();
        }
        return this.logs.splice(0, logsCount);
    };
    // pops all logs in the list
    LogStore.prototype.popAllLogs = function () {
        return this.logs.splice(0, this.getSize());
    };
    LogStore.prototype.clear = function () {
        this.logs.length = 0;
    };
    return LogStore;
}());
exports.LogStore = LogStore;
//# sourceMappingURL=LogStore.js.map